import React from 'react';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import i18n from 'i18n';
import BlockHeader from 'components/common/BlockHeader';
import Button from 'components/common/Button';
import {
  pcStyle as tablePCStyle,
  spStyle as tableSPStyle
} from 'components/OrderAggregators/styles/table';
import PaymentType from 'constants/payment-type';
import PaymentDialog from 'components/OrderAggregators/components/PaymentDialog';

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.paymentDialogRef = React.createRef();
  }

  render() {
    const { className, form, closeAlert, showAlert } = this.props;
    const payment = form.getState().values.payment;

    if (!payment) {
      return null;
    }

    return (
      <div className={className}>
        <BlockHeader>
          {i18n.t('orderAggregators:confirmation:paymentInfo')}
        </BlockHeader>
        <table className="confirm-table">
          <tbody>
            {payment.type === PaymentType.card ? (
              <React.Fragment>
                <tr>
                  <th>{i18n.t('orderAggregators:confirmation:paymentType')}</th>
                  <td>{i18n.t('orderAggregators:confirmation:card')}</td>
                </tr>
                <tr>
                  <th>{i18n.t('orderAggregators:confirmation:cardNo')}</th>
                  <td>{payment.maskedCardNo}</td>
                </tr>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <tr>
                  <th>{i18n.t('orderAggregators:confirmation:paymentType')}</th>
                  <td>{i18n.t('orderAggregators:confirmation:bank')}</td>
                </tr>
                <tr>
                  <th>
                    {i18n.t('orderAggregators:confirmation:transferAccount')}
                  </th>
                  <td>
                    {i18n.t(
                      'orderAggregators:confirmation:transferAccountNote'
                    )}
                  </td>
                </tr>
                <tr>
                  <th>{i18n.t('orderAggregators:confirmation:transferFee')}</th>
                  <td>
                    {i18n.t('orderAggregators:confirmation:transferFeeNote')}
                  </td>
                </tr>
                <tr>
                  <th>{i18n.t('orderAggregators:confirmation:payerName')}</th>
                  <td>{payment.payerName}</td>
                </tr>

                <tr>
                  <th>
                    {i18n.t('orderAggregators:confirmation:transferDate')}
                  </th>
                  <td>
                    {i18n.t('orderAggregators:confirmation:transferDateNote')}
                  </td>
                </tr>
              </React.Fragment>
            )}
          </tbody>
        </table>
        <div className="btn-wrapper">
          <Button
            buttonType="F"
            type="button"
            onClick={() => { this.paymentDialogRef.current.open(); if (window.aerosmith !== undefined) { window.aerosmith.init() } }}
          >
            {i18n.t('orderAggregators:confirmation:edit')}
          </Button>
        </div>
        <PaymentDialog
          dialogRef={this.paymentDialogRef}
          form={form}
          showAlert={showAlert}
          closeAlert={closeAlert}
        />
      </div>
    );
  }
}

const pcStyle = CustomMedia.greaterThan('umedium')`
  .btn-wrapper {
    width: 100%;
    margin: 24px 0 0;
    text-align: center;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .btn-wrapper {
    width: 100%;
    text-align: center;
    padding-top: 16px;
  }
`;

export default applyStyles(Payment)(
  pcStyle,
  spStyle,
  tablePCStyle,
  tableSPStyle
);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/components/Payment.js